/**
 * @module paymentStatus
 * @description A list of paymentStatus
 */

export const paymentStatus = [
	'processed',
	'cancelled',
	'pending',
	'failed',
	'refunded',
] as const;
export type PaymentStatus = (typeof paymentStatus)[number];
